const side_nav = {
	administration: {
		budget: "Inkomsten/uitgaven",
		discounts: "Kortingen",
		invoices: "Facturen",
		orders: "Orders",
		quotes: "Offertes",
		title: "Administratie",
	},
	customers: {
		debtor_groups: "Debiteurgroepen",
		debtors: "Debiteuren",
		title: "Klanten",
		users: "Gebruikers",
	},
	domains: {
		management: "Beheren",
		register: "Registreren",
		title: "Domeinnamen",
	},
	management: {
		api_keys: "API keys",
		ip_blacklist: "IP blacklist",
		logs: "Logs",
		ns_groups: "Custom NS-groepen",
		sla_overview: "SLA overzicht",
		staff: "Medewerkers",
		title: "Beheer",
	},
	pbs: {
		management: "Beheren",
		register: "Aanmaken",
		title: "Tuxis PBS",
	},
	products: {
		product_groups: "Productgroepen",
		products: "Producten",
		title: "Producten",
	},
	shared: {
		relations: "Relaties",
	},
	vps: {
		create: "Aanmaken",
		management: "Beheren",
		private_network: "Private networks",
		title: "Virtual private servers",
	},
};

export default side_nav;
